import { Comparator } from '../../services/sorting.service';
import { SortDirection } from '../../components/datatable/types/sort-direction.type';
import { TableSort, TableSorts } from '../../components/datatable/types/sort.type';

export interface SortByDefinition {
  property: string;
  resourceKey: string;
  comparator?: Comparator;
}

export interface SortByOption extends SortByDefinition {
  direction: SortDirection;
}
export class SortByOptionHelper {

  static comparator(sortBy1: SortByOption, sortBy2: SortByOption): boolean {
    return (sortBy1 !== undefined && sortBy1 !== null && sortBy2 !== undefined && sortBy2 !== null &&
      (sortBy1.property === sortBy2.property && sortBy1.direction === sortBy2.direction)) ||
      (sortBy1 === undefined && sortBy2 === undefined);
  }

  /**
   * Conversion from TableSort to SortByOption. Might return undefined if sortByColumns do not contain the sorted column
   * passed in TableSorts.
   */
  static convertFromTableSorts(sorts: TableSorts, sortByColumns: Array<SortByDefinition>): SortByOption {
    if (sorts !== undefined && sorts.sorts !== undefined && sorts.sorts.length > 0) {
      return SortByOptionHelper.convertFromTableSort(sorts.sorts[0], sortByColumns);
    }
    return undefined;
  }

  /**
   * Conversion from TableSort to SortByOption. Might return undefined if sortByColumns do not contain the sorted column
   * passed in TableSorts.
   */
  static convertFromTableSort(sort: TableSort, sortByColumns: Array<SortByDefinition>): SortByOption {
    let sortBy: SortByOption;
    if (sort !== undefined) {
      const sortByDefinition: SortByDefinition = sortByColumns
        .find((definition: SortByDefinition): boolean => definition.property === sort.prop);
      if (sortByDefinition !== undefined) {
        sortBy = { ...{ direction: sort.dir }, ...sortByDefinition };
      }
    }
    return sortBy;
  }

  /**
   * Conversion from SortByOption to TableSort.
   */
  static convertToTableSort(sortByOption: SortByOption): TableSort {
    return {
      dir: sortByOption?.direction,
      prop: sortByOption?.property
    };
  }
}
